import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobile: false,
  isMobileMenuOpen: false,
  registrationInfo: {
    email: '',
    plan: 'oneMonth',
  },
  funnelButtonDisabled: true,
  cookieInfo: false,
  params: {},
};

export const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setIsMobileMenuOpen: (state, action) => {
      state.isMobileMenuOpen = action.payload;
    },
    setEmail: (state, action) => {
      state.registrationInfo.email = action.payload;
    },
    setPlan: (state, action) => {
      state.registrationInfo.plan = action.payload;
    },
    setFunnelButtonDisabled: (state, action) => {
      state.funnelButtonDisabled = action.payload;
    },
    setCookieInfo: (state, action) => {
      state.cookieInfo = action.payload;
    },
    setParams: (state, action) => {
      const { key, value } = action.payload;
      state.params = { ...state.params, [key]: value };
    },
  },
});

export const { setIsMobile, setIsMobileMenuOpen, setEmail, setFunnelButtonDisabled, setCookieInfo, setParams } =
  mainSlice.actions;

export const selectIsMobile = (state) => state.main.isMobile;
export const selectIsMobileMenuOpen = (state) => state.main.isMobileMenuOpen;
export const selectFunnelButtonDisabled = (state) => state.main.funnelButtonDisabled;
export const selectEmail = (state) => state.main.registrationInfo.email;
export const selectCookieInfo = (state) => state.main.cookieInfo;

export default mainSlice.reducer;
